import { UntypedFormGroup } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export enum SettingsGroups {
    equipoBase = 'EQUIPO BASE',
    tanqueSolucion = 'TANQUE DE SOLUCION',
    bombasCarga = 'BOMBAS DE CARGA',
    comandoMovimientos = 'COMANDO DE MOVIMIENTOS',
    trocha = 'TROCHA',
    botalon = 'BOTALON',
    computadoras = 'COMPUTADORAS',
    generales = 'GENERALES',
}
export enum SettingsGroupsInverse {
    'EQUIPO BASE' = 'equipoBase',
    'TANQUE DE SOLUCION' = 'tanqueSolucion',
    'BOMBAS DE CARGA' = 'bombasCarga',
    'COMANDO DE MOVIMIENTOS' = 'comandoMovimientos',
    'TROCHA' = 'trocha',
    'BOTALON' = 'botalon',
    'COMPUTADORAS' = 'computadoras',
    'GENERALES' = 'generales'
}

export enum TasksStatusesLabels {
    pending = 'Pendiente',
    finished = 'Finalizada',
    in_progress = 'En curso',
    delayed = 'Retrasada',
    pause = 'En pausa'
}
export enum TasksStatusesBgColor {
    pending = 'bg-pending',
    finished = 'bg-finished',
    in_progress = 'bg-inProgress',
    delayed = 'bg-delayed',
    pause = 'bg-pause'
}

export enum TasksStatusesFilter {
    finished = 'Finalizada',
    inProgress = 'En curso',
    delayed = 'Retrasada',
    pending = 'Pendiente'
}

export const TasksStatuses = [
    {
        name: 'finished',
        label: 'Finalizada',
        color: 'success',
        hide: false
    },
    {
        name: 'in_progress',
        label: 'En curso',
        color: 'warning',
        hide: false
    },
    {
        name: 'delayed',
        label: 'Retrasada',
        color: 'danger',
        hide: false
    },
    {
        name: 'pending',
        label: 'Pendiente',
        color: 'primary',
        hide: false
    }
];

export enum TasksStatusesFilterReverse {
    'Finalizada' = 'finished',
    'En curso' = 'in_progress',
    'Retrasada' = 'delayed',
    'Pendiente' = 'pending'
}

export function getTaskStatusColor(status) {
    const color = 'success';

    const task = TasksStatuses.find(taskStatus => taskStatus.name === status);
    if (task) {
        return task.color;
    }
    return color;
}

export function isNull(field) {

    let valid = false;
    if (field === null) {
        valid = true;
    }

    return valid;
}

export function isUndefined(field) {
    return field === undefined;
}

export function isNullOrEmpty(field) {
    let valid = false;
    if (field === '' || !field || field === null) {
        valid = true;
    }
    return valid;
}

export function isEmpty(field) {
    let valid = false;
    if (field === '') {
        valid = true;
    }
    return valid;
}

export function isNullOrEmptyOrUndefined(field) {
    let valid = false;
    if (field === '' || field === null || field === undefined) {
        valid = true;
    }
    return valid;
}

export function isString(item: any) {
    return typeof item === 'string';
}

export function toModelDate(date: NgbDateStruct): Date {
    return date ? new Date(date.year + '-' + date.month + '-' + date.day + ' 00:00:00') : null;
}

export function removeValidators(form: UntypedFormGroup, field) {
    form.get(field).clearValidators();
    form.get(field).updateValueAndValidity();
}
